var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",attrs:{"data-component":"layout"}},[_c('header-menu'),_c('transition',{attrs:{"name":"slide-right","mode":"out-in"}},[_c('router-view')],1),_c('Footer'),_c('scroll-up')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }